/* eslint-disable @typescript-eslint/consistent-type-imports */
import axios from 'axios';
import type { Currency } from 'types';

const getCurrencyConversionRate = async ({
  customerCurrencyValue,
  shopCurrency
}: {
  shopCurrency: Currency;
  customerCurrencyValue: string;
  // eslint-disable-next-line sonarjs/cognitive-complexity
}): Promise<number> => {
  let fee = 1;
  let rate = 1;
  if (shopCurrency.multiCurrency && shopCurrency.value !== customerCurrencyValue) {
    try {
      // @ts-ignore
      rate = Currency.convert(1, shopCurrency.value, customerCurrencyValue);
    } catch (e) {
      try {
        const { data } = await axios.get('https://api.exchangerate.host/convert', {
          params: { from: shopCurrency.value, to: customerCurrencyValue }
        });
        if (data.result) rate = data.result;
        else console.error(`Currency conversion failed ${data.error.info}`);
      } catch (e) {
        console.error('Currency conversion failed', e);
      }
    }

    if (rate !== 1)
      if (shopCurrency.value === 'USD') fee = 1.02;
      else fee = 1.015;
  }
  console.debug(`currency converted`, {
    customerCurrency: customerCurrencyValue,
    fee,
    multiCurrency: shopCurrency.multiCurrency,
    rate,
    shopCurrency: shopCurrency.value
  });
  return rate * fee;
};

export default getCurrencyConversionRate;
